import React from 'react';
import { ThemeProvider } from '../features/risks/theme/ThemeProvider';
import DeviceHistoryPage from '../features/risks/pages/DeviceHistoryPage';
import '../features/risks/styles/risks.css';

/** Device history under /risks — same shell as Risks (sidebar + risks theme). */
const RisksDeviceHistory = () => {
  return (
    <ThemeProvider>
      <div className="risks-root w-full p-4 md:p-6 bg-slate-50 text-slate-900">
        <DeviceHistoryPage />
      </div>
    </ThemeProvider>
  );
};

export default RisksDeviceHistory;
